import { numericFormatter } from "react-number-format";
import { columns } from "../../../dtos/columns";
import Conversiones from "../../../utils/conversiones";
import { CobradorMinvuDto } from "./models/modelsCobradorMinvu";
import { getDescriptionEstadoSubsidioMINVU } from "../../contabilidad/validadorAsientos/utils/utils";


export function useColumns() {

    const COLUMNS: columns<CobradorMinvuDto>[] = [
        {
            name: 'N° operación',
            selector: (row) =>
                row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'Rut cliente',
            selector: (row) => row.rut,
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Cliente',
            selector: (row) =>
                `${row.deudor}`,
            sortable: true,
            sortField: 'deudor',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'N° dividendo',
            selector: (row) =>
                `${row.numeroDividendo}`,
            sortable: true,
            sortField: 'deudor',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Fecha vencimiento',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechaVencimiento?.toString() ?? ""),
            sortable: true,
            sortField: 'fechaVencimiento',
            wrap: true,
            export: true,
        },
        {
            name: 'Estado',
            selector: (row) =>
                getDescriptionEstadoSubsidioMINVU(row.estado),
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha estado',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechaEstado?.toString() ?? ""),
            sortable: true,
            sortField: 'fechaEstado',
            wrap: true,
            export: true,
        },
        {
            name: 'Beneficio',
            selector: (row) =>
                row.beneficio,
            sortable: true,
            sortField: 'beneficio',
            wrap: true,
            export: true,
        },
        {
            name: 'Subvención',
            selector: (row) =>
                !row.porcentaje ? "" : numericFormatter(row.porcentaje?.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": "%" }),
            sortable: true,
            sortField: 'porcentaje',
            wrap: true,
            export: true,
        },
        {
            name: 'Monto beneficio',
            selector: (row) =>
                row.beneficio,
            sortable: true,
            sortField: 'beneficio',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha pago',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechaPago?.toString() ?? ""),
            sortable: true,
            sortField: 'beneficio',
            wrap: true,
            export: true,
        }
    ]


    return { COLUMNS };
}